export const PRODUCT_NAME = 'customer_portal';
export const TRACKING_FROM = 'frontend';

export const TRACKING_REPORT_DELAY = 5000;
